import { useCallback } from "react";

type SortDir = "asc" | "desc";

interface THProps<K extends string> {
  sortKey: K;
  current: K;
  direction: SortDir;
  onClick: (key: K) => void;
}

interface ColumnSort<K extends string> {
  thProps: (key: K) => THProps<K>;
}

export function useColumnSort<K extends string>(
  columnMap: Record<K, string>,
  sortBy: string,
  sortDir: SortDir,
  setSort: (by: string, dir: SortDir) => void,
): ColumnSort<K> {
  let current = "" as K;
  for (const key in columnMap) {
    if (columnMap[key] === sortBy) {
      current = key;
      break;
    }
  }

  const onClick = useCallback(
    (key: K) => {
      const col = columnMap[key];
      const next: SortDir = col === sortBy && sortDir === "asc" ? "desc" : "asc";
      setSort(col, next);
    },
    [columnMap, sortBy, sortDir, setSort],
  );

  const thProps = useCallback(
    (key: K): THProps<K> => ({ sortKey: key, current, direction: sortDir, onClick }),
    [current, sortDir, onClick],
  );

  return { thProps };
}
